import {
    ADD_AUTHORIZED_APP,
    UPDATE_AUTHORIZED_APP,
    DELETE_AUTHORIZED_APP,
} from './authorizedAppsConstants';
import db from '../../db';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';

export function authorizedAppsHasErrored(bool) {
    return {
        type: 'AUTHORIZED_APPS_HAS_ERRORED',
        hasErrored: bool
    };
}
export function authorizedAppsIsLoading(bool) {
    return {
        type: 'AUTHORIZED_APPS_IS_LOADING',
        isLoading: bool
    };
}
export function authorizedAppsFetchDataSuccess(authorizedApps) {
    return {
        type: 'AUTHORIZED_APPS_FETCH_DATA_SUCCESS',
        authorizedApps
    };
}

export function haveModuleAuthorization(moduleName, user) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(authorizedAppsIsLoading(true));
            const headers = new Headers({ 'Content-Type': 'application/json' });
            return fetchWithTimeout('/api/v1/get_authorized_apps/' + user.id, {
                method: 'GET',
                headers: headers,
            })
                .then((response) => {
                    dispatch(authorizedAppsIsLoading(false));
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((authorizedModules) =>
                    resolve(authorizedModules.filter((authorizedModule) => authorizedModule.code === moduleName).length > 0)
                ).catch((err) => {
                    console.error("authorizedAppsActions - haveModuleAuthorization", err)
                    dispatch(authorizedAppsIsLoading(false));
                    dispatch(authorizedAppsHasErrored(true));
                    return reject()
                });
        })
    }
}

export function authorizedAppsFetchData(user) {
    return (dispatch) => {
        dispatch(authorizedAppsIsLoading(true));
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/get_authorized_apps/' + user.id, {
            method: 'GET',
            headers: headers,
        })
            .then((response) => {
                dispatch(authorizedAppsIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((authorizedApps) => dispatch(authorizedAppsFetchDataSuccess(authorizedApps)))
            .catch((err) => {
                console.error("Erreur lors de la récupération des applications autorisées", err)
                dispatch(authorizedAppsIsLoading(false));
                /* L'utilisateur n'a pas à connaitre cette information
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération des applications autorisées !",
            }));*/
                dispatch(authorizedAppsHasErrored(true))
            });
    };
}


/**/



export function addauthorizedApp(data) {
    return (dispatch) => {
        const authorizedAppToAdd = data;
        db.table('authorizedApps')
            .add(authorizedAppToAdd)
            .then((id) => {
                dispatch({
                    type: ADD_AUTHORIZED_APP,
                    payload: Object.assign({}, authorizedAppToAdd, { id }),
                });
            });
    }
}

export function deleteauthorizedApp(id) {
    return (dispatch) => {
        db.table('authorizedApps')
            .delete(id)
            .then(() => {
                dispatch({
                    type: DELETE_AUTHORIZED_APP,
                    payload: id,
                });
            });
    };
}

export function updateauthorizedApp(id, data) {
    return (dispatch) => {
        db.table('authorizedApps')
            .update(id, data)
            .then(() => {
                dispatch({
                    type: UPDATE_AUTHORIZED_APP,
                    payload: { id, data },
                });
            });
    };
}
